import { useIntl } from "react-intl";

import { SubmitButton } from "@/components/signup/site-activation/components/common/submit-button";

export const SubmitButtonExistingUser = () => {
    const intl = useIntl();

    const submitMessage = intl.formatMessage({
        id: "WacSignupForm.FirstImpressions.submitButtonLabel",
        defaultMessage: "Agree"
    });

    return <SubmitButton submitMessage={submitMessage} />;
};
